jQuery(document).ready(function($) {

 $("button[aria-controls='product-quick-buy-template--16129959461016__featured-collections-collection-1--7719752204440']").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });



  $("sold-out-badge.badge.badge--sold-out").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
  $("on-sale-badge.badge.badge--on-sale").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
  


  let Intervaltime3;
let counter = 0; // counter to track the number of times the function is called

try {
    Intervaltime3 = setInterval(GenerateAriaLabelForPopup, 500);
}
catch (err) {
  
}

function GenerateAriaLabelForPopup() {
    // Increment the counter each time the function is called
    counter++;

    // Check if the target element exists
    if ($("img.rapoImgp").length) {
        $("img.rapoImgp").attr("alt","Amazon customer reviews images");

    $("img.zom-img").attr("alt","zoom Amazon customer review image");
    $("h3:empty").append("<span style='display:none'>.</span>")
        clearInterval(Intervaltime3);
      
    }
    
    // Clear the interval if the function has been called 10 times
    if (counter >= 20) {
        clearInterval(Intervaltime3);
       
    }
}
  $('img[src="//www.maisonovo.com/cdn/shop/files/Maisonovo_logo_-_black500px-03_1.svg?v=1697224397&width=140"]').attr('alt', 'Maisonovo logo');
$("h6:empty").append("<span style='display:none'>.</span>");
  $('img[src="https://cdn.shopify.com/s/files/1/0471/2559/4264/files/WB1.1_600x600.jpg?v=1655816229"]').attr('alt', 'hand soap and lotion bottle on shelf');

$('img[src="https://cdn.shopify.com/s/files/1/0471/2559/4264/files/Margaux-Colletion-B-15_600x600.jpg?v=1655875394"]').attr('alt', 'hand soap and lotion on kitchen shelf');

$('img[src="https://cdn.shopify.com/s/files/1/0471/2559/4264/files/Margaux-Colletion-B-15_600x600.jpg?v=1655875394"]').attr('alt', 'maisonovo collection');
$('img[src="https://cdn.shopify.com/s/files/1/0471/2559/4264/products/FH9A5355_2160e418-5454-4aee-9151-ca7ceb7fdbca_600x600.jpg?v=1653469303"]').attr('alt', 'product image');
$('img[src="https://cdn.shopify.com/s/files/1/0471/2559/4264/files/mn-_8-of-28_600x600.jpg?v=1655878688"]').attr('alt', 'bottles at kitchen shank');

$('img[src="https://cdn.shopify.com/s/files/1/0471/2559/4264/files/Margaux_Mix_Pink_600x600.png?v=1655817143"]').attr('alt', 'maisonovo collection labels');
$('img[src="//www.maisonovo.com/cdn/shop/files/2_image_8e22553e-5da7-4644-80c7-1c48eadebb40.jpg?v=1734942380"]').attr('alt', 'Customer avatar');

$('img[src="//www.maisonovo.com/cdn/shop/files/cwo_1_1.png?v=1732639556"]').attr('alt', 'Customer avatar');

$('img[src="//www.maisonovo.com/cdn/shop/files/1_image_224c9a3c-0edb-4fca-9363-127654cd3cd2.jpg?v=1734942381"]').attr('alt', 'Customer avatar');

$('img[src="//www.maisonovo.com/cdn/shop/files/5_image.png?v=1734942669"]').attr('alt', 'Customer avatar');

$('img[src="//www.maisonovo.com/cdn/shop/files/4_image.jpg?v=1734942669"]').attr('alt', 'Customer avatar');
$('img[src="//www.maisonovo.com/cdn/shop/files/3_image.png?v=1734942669"]').attr('alt', 'Customer avatar');

$('img[src="https://cdn.shopify.com/s/files/1/0471/2559/4264/files/svgexport-17.svg?v=1736616166"]').attr('alt', 'Heart icon');

$('img[src="https://cdn.shopify.com/s/files/1/0471/2559/4264/files/svgexport-16.svg?v=1736616166"]').attr('alt', 'Green leaf icon');

$('img[src="https://cdn.shopify.com/s/files/1/0471/2559/4264/files/svgexport-15.svg?v=1736616166"]').attr('alt', 'Dimensions icon');

$('img[src="https://cdn.shopify.com/s/files/1/0471/2559/4264/files/svgexport-14.svg?v=1736616167"]').attr('alt', 'Drop icon');

$('img[src="https://cdn.shopify.com/s/files/1/0471/2559/4264/files/svgexport-13.svg?v=1736616167"]').attr('alt', 'Design icon');
$("img.r-10x2ee6").attr("alt","customer showing product via testimonials");
$('img[src="https://cdn.shopify.com/s/files/1/0718/6979/2564/files/wm1__1.png?v=1736490886"]').attr('alt', '5 Reasons Why Our Dispenser Makes You Feel Better at Home');

$('img[src="//www.maisonovo.com/cdn/shop/files/01_BlackMetal.jpg?v=1736503596"]').attr('alt', 'Dispenser bottles in black metal');

$('img[src="//www.maisonovo.com/cdn/shop/files/01_Black_x3_ca728997-272d-4de3-b36b-b47f20ca27cd.jpg?v=1736503596"]').attr('alt', 'Shampoo, conditioner, and body lotion in black metal bottles');

$('img[src="//www.maisonovo.com/cdn/shop/files/02_Black_x3_13053f88-0664-42d7-8bf4-115bf4d11f7e.jpg?v=1736503596"]').attr('alt', 'Shower soap dispenser in black bottle');

$('img[src="//www.maisonovo.com/cdn/shop/files/03_Black_x3_1c80f9bd-061b-4711-9564-01e56dc94844.jpg?v=1736503596"]').attr('alt', 'Shower shampoo and conditioner in black bottles');

$('img[src="https://cdn.shopify.com/s/files/1/0718/6979/2564/files/Shop_Pay_logo_svg.png?v=1736509525"]').attr('alt', 'Shop Pay logo');

$('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/UjbH6d/images/213beb8d-676e-433d-a881-7a2a547e6273.png"]').attr('alt', 'Maisonovo logo');
$('a[href="/pages/shower-dispensers"]').attr('aria-label', 'Shower dispensers page');

$('a[href="https://www.maisonovo.com/collections/hand-soap-refills?sort_by=created-descending"]').attr('aria-label', 'Maisonovo hand soap refills collection sorted by newest arrivals');

$('img[src="https://cdn.shopify.com/s/files/1/0471/2559/4264/files/MaisoNovo-15-2_97ed222b-e184-4489-9c57-77a6443734be_600x600.jpg?v=1655880810"]').attr('alt', 'shampoo, conditioner and body wash bottles mounted on shelf');
let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;

$('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/UjbH6d/images/6921f0ff-19da-45f4-a25f-4eb39ddb934e.png"]').attr('alt', 'Collection of Maisonovo hand soap, dish soap, and lotion bottles');
   $('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/UjbH6d/images/213beb8d-676e-433d-a881-7a2a547e6273.png"]').attr('alt', 'Maisonovo logo');
    if ( $('#goog-gt-votingInputSrcLang').length) {
$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
      
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 10) {
        clearInterval(Intervaltime_google);
       
    }
}
$('img[src="https://cdn.shopify.com/s/files/1/0471/2559/4264/files/Clear_600x600.jpg?v=1655880703"]').attr('alt', 'body wash, shampoo and conditioner in clear bottles');
   $('img[src="//www.maisonovo.com/cdn/shop/files/Frame_195_2.png?v=1700849299&width=1440"]').attr('alt', 'maisonovo banner');
$('img[src="https://cdn.shopify.com/s/files/1/0471/2559/4264/files/linli_louisa_photos_touch_up_2000x2000_lv_16-feb-2021_Margaux_Colletion-30_d046dc33-bc37-4493-9353-7c302a0c57aa_600x600.jpg?v=1655881168"]').attr('alt', 'hand soap bottle');
$('a[href="/products/maisonovo-shampoo-dispenser-for-shower-wall-3-chamber-drill-free-shower-soap-dispenser-wall-mount-with-waterproof-labels-3-clear-bottles-3-silver-wall-mounts"]').attr('aria-label', 'Maisonovo Shampoo Dispenser for Shower Wall product');
$('img[src="https://cdn.shopify.com/s/files/1/0471/2559/4264/files/Banner-Design-600x180_GK_02_Oct_2020-V2-1_600x600.jpg?v=1655881979"]').attr('alt', 'beautiful bathroom design');
$('a[href="/collections/bamboo-dispensers"]').attr('aria-label', 'Bamboo dispensers collection');
$('img[src="//www.maisonovo.com/cdn/shop/files/Frame_45_1.svg?v=1700851355"], ' +
  'img[src="//www.maisonovo.com/cdn/shop/files/Frame_45_5.svg?v=1700851357"], ' +
  'img[src="//www.maisonovo.com/cdn/shop/files/Frame_45.svg?v=1697477184"], ' +
  'img[src="//www.maisonovo.com/cdn/shop/files/Frame_45_2.svg?v=1700851355"], ' +
  'img[src="//www.maisonovo.com/cdn/shop/files/Frame_45_4.svg?v=1700851356"], ' +
  'img[src="//www.maisonovo.com/cdn/shop/files/Frame_45_3.svg?v=1700851357"]')
  .attr('alt', 'happy customer');
$('img[src="//www.maisonovo.com/cdn/shop/files/Icons-06_1.svg?v=1700706840&width=125"]').attr('alt', 'women avatar');
$('img[src="//www.maisonovo.com/cdn/shop/files/Icons-07_1.svg?v=1700770008&width=124"]').attr('alt', 'bottles');
$('img[src="//www.maisonovo.com/cdn/shop/files/Icons-08_1.svg?v=1700770126&width=125"]').attr('alt', 'environment friendly');
$('img[src="//www.maisonovo.com/cdn/shop/files/Frame_193.jpg?v=1700585765&width=1204"]').attr('alt', 'girl smiling and posing for a picture');
  $('img[src="//www.maisonovo.com/cdn/shop/files/Frame_200.jpg?v=1701796606&width=2880"]').attr('alt', 'Affiliate banner');
 $('img[src="//www.maisonovo.com/cdn/shop/files/02_form_1.svg?v=1700684529&width=124"]').attr('alt', 'online form');
   $('img[src="//www.maisonovo.com/cdn/shop/files/Icons-02_1.svg?v=1700684529&width=124"]').attr('alt', 'cart');
  $('img[src="//www.maisonovo.com/cdn/shop/files/Icons-02_1.svg?v=1700684529&width=124"]').attr('alt', 'cart');
    $('img[src="//www.maisonovo.com/cdn/shop/files/03_world_1.svg?v=1700684530&width=124"]').attr('alt', 'spread the word');
   $('img[src="//www.maisonovo.com/cdn/shop/files/04_connect_device_1.svg?v=1700684530&width=124"]').attr('alt', 'responsive design');

  $("input.sr-only[name='option1']").attr("aria-label","Select option");
$("h1:empty").append("<span style='display:none'>.</span>");
  $("h3:empty").append("<span style='display:none'>.</span>")
console.log( "ready!" );
});

